import { Link } from "react-router-dom";
import SvgIcon from "./svgr/Icon";

export function Footer() {
  return (
    <div className="relative bottom-0 w-full items-center bg-brown py-10">
      <div className="m-auto max-w-screen-sm px-3">
        <div className="flex flex-row items-center justify-center">
          <SvgIcon width={50} className="max-w-[150px] fill-white" aria-label="logo icon" />
        </div>
        <div className="mt-4 flex flex-col gap-2">
          <FooterLink label="About" href="/" />
          <FooterLink label="Terms & Conditions" href="/" />
          <FooterLink label="Privacy Notice" href="/" />
          <FooterLink label="Send Us Feedback" href="/" />
          <div className="text-md font-medium text-white" style={{ color: "white" }}>
            © 2024 | Somedubs | All Rights Reserved
          </div>
        </div>
      </div>
    </div>
  );
}

function FooterLink({ href, label }: { label: string; href: string }) {
  return (
    <Link className="text-md font-medium text-white" to={href} style={{ color: "white" }}>
      {label}
    </Link>
  );
}
